import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PlannerLayoutComponent } from './planner-layout.component';


export class PlannerLayoutModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [ CommonModule ],
  declarations: [ PlannerLayoutComponent ],
  exports: [ PlannerLayoutComponent ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
